<template>
  <div>
    <HeaderTop :header="header" />
    <HeaderBanner
      :info="header.GettyHeader"
      :banner="whichBannerItem"
      :route="route"
    />
    <HeaderNav :info="header.GettyNav" :route="route" :nav="whichNavItem" />
  </div>
</template>

<script>
import HeaderBanner from "@/components/HeaderBanner";
import HeaderNav from "@/components/HeaderNav";
import HeaderTop from "@/components/HeaderTop";

export default {
  name: "HeaderDesktop",
  data() {
    return {};
  },
  props: {
    header: Object,
    route: String
  },
  computed: {
    whichBanner() {
      if (this.route && this.route.includes("gci")) {
        return "gci";
      } else if (this.route && this.route.includes("virtuallibrary")) {
        return "publications";
      } else if (this.route && this.route.includes("museumed")) {
        return "museum";
      } else if (this.route && this.route.includes("kim")) {
        return "foundation";
      } else {
        return "getty";
      }
    },
    whichBannerItem() {
      return this.index(this.header.GettyHeader, this.whichBanner);
    },
    whichNav() {
      if (this.route && this.route.includes("go")) {
        return "go";
      } else if (this.route && this.route.includes("gcipub")) {
        return "gcipub";
      } else if (this.route && this.route.includes("gci")) {
        return "gci";
      } else if (this.route && this.route.includes("virtuallibrary")) {
        return "publications";
      } else if (this.route && this.route.includes("museumed")) {
        return "museum";
      } else if (this.route && this.route.includes("kim")) {
        return "foundation";
      } else {
        return "home";
      }
    },
    whichNavItem() {
      return this.index(this.header.GettyNav, this.whichNav);
    }
  },
  components: {
    HeaderBanner,
    HeaderNav,
    HeaderTop
  },
  methods: {
    index(obj, is, value) {
      if (typeof is == "string") return this.index(obj, is.split("."), value);
      else if (is.length == 1 && value !== undefined)
        return (obj[is[0]] = value);
      else if (is.length == 0) return obj;
      else return this.index(obj[is[0]], is.slice(1), value);
    }
  }
};
</script>
